import { FaQuestionCircle } from "react-icons/fa"
import styled from "styled-components"
import { TooltipWrapper } from "@prosolve/common-components-ui"
import MarkDeliveredButton from "../OrderDetails/MarkDeliveredButton"
import ViewOrderExternalButton from "./ViewOrderExternalButton"

const Statuses = styled.div`
  display: flex;
  flex: 1;
`

const StatusItem = styled.div`
  color: #565656;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 10px;
  text-align: center;
  border-right: solid 1px #dedede;
  border-bottom: solid 1px #dedede;
  padding: 8px 0;
`

const StatusButtons = styled.div`
  display: flex;
  gap: 10px;

  & > div {
    height: 18px !important;
    font-size: 14px;
  }
`

/*
const trackingMapSbCarrier = [
  'FedEx', 
  'ShipBob Freight'
]
*/

export default ({
  orderEx,
  isInactive,
  updateSbOrderData
}) => {
  const {
    dataSb
  } = orderEx

  const {
    source,
    shipping_terms,
    status_derived
  } = dataSb || {}

  const isSb = source === 'sb'
  const isSbFreight = shipping_terms?.carrier_type === 'Freight'
  const isComplete = status_derived === 'Completed'
  const isShow = isSb && isSbFreight && !isComplete && !isInactive

  return (
    isShow
    ?
    <div>
      <Statuses>
        <StatusItem>
          <TooltipWrapper text={'ShipBob Freight does not provide tracking or status updates once shipped. Orders must be manually marked as delivered.'}>
            <FaQuestionCircle style={{ fontSize: '14px', marginRight: '5px' }} />
            <span>ShipBob Freight</span>
          </TooltipWrapper>
          <StatusButtons>
            <ViewOrderExternalButton orderEx={orderEx} />
            <MarkDeliveredButton orderEx={orderEx} updateSbOrderData={updateSbOrderData} />
          </StatusButtons>
        </StatusItem>
      </Statuses>
    </div>
    : 
    <></>
  )
}
